/* eslint-disable jsx-a11y/label-has-for */
// this rule is deprecated so I'm ignoring it.
// https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/master/docs/rules/label-has-for.md

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useRequestData, useLabels } from 'wsm-common-data';
import { trackEvent } from 'ddc-track-event';
import { setClassNames } from '@ddc/classnames-js';

const InventorySort = ({ sortOptions, isBtn /* displayStyle */ }) => {
	const { widgetName, windowId } = useRequestData();
	const labels = useLabels();
	const [sortAnnouncement, setSortAnnouncement] = useState('');
	const [isFocused, setIsFocused] = useState(false);

	const handleChange = (e) => {
		const { value } = e.target;
		const selectedOption = sortOptions.find((o) => o.value === value);

		trackEvent(widgetName, windowId, {
			element: 'Sort select',
			elementCTA: value,
			fieldValue: value,
			result: 'Results updated with sort selection'
		});

		window.DDC.InvData.setSortBy(value || '');

		window.DDC.pushToGtmDataLayer({
			event: 'ddc.form.change',
			eventData: {
				element: e.target,
				event: 'ddc.form.change',
				formEventId: '',
				label: selectedOption.label,
				linkType: 'select-one',
				widgetName: 'ws-inv-listing'
			}
		});

		// Announce sort change to screen readers
		// Note: This state update also triggers an immediate re-render, which
		// causes the select to reflect the new sort value instantly (without it,
		// the select only updates on the next external re-render).
		setSortAnnouncement(
			value
				? labels
						.get('SORTED_BY_X')
						.replace('{sort option}', selectedOption.label)
				: labels.get('SORT_ORDER_CLEARED')
		);
	};

	const handleFocus = () => {
		setIsFocused(true);
	};

	const handleBlur = () => {
		setIsFocused(false);
	};

	// TODO: Uncomment this once the utility class for sort dropdown is finalized

	// const sortClasses = `form-control ${
	// 	displayStyle === 'transparent' ? 'form-control-transparent' : ''
	// }`.trim();

	const selectedValue = window.DDC.InvData.getSortBy();
	const currentValue = Array.isArray(selectedValue)
		? selectedValue[0]
		: selectedValue;

	if (!sortOptions || !sortOptions.length) return null;

	if (isBtn) {
		const selectedOption = sortOptions.find(
			(opt) => opt.value === currentValue
		);
		const displayLabel =
			selectedOption && selectedOption.value
				? selectedOption.label
				: labels.get('SORT');

		return (
			<React.Fragment>
				<div
					id="inventory-sort-button"
					className={setClassNames([
						'btn',
						'btn-default',
						'btn--custom-focus',
						'font-weight-bold',
						'position-relative',
						'pointer',
						'text-nowrap',
						'd-inline-block',
						isFocused && 'focus'
					])}
				>
					<i
						className="ddc-icon ddc-icon-up-down pointer align-middle line-height-reset"
						aria-hidden="true"
					/>{' '}
					<span className="pointer" aria-hidden="true">
						{displayLabel}
					</span>
					<select
						className="pointer absolute-top absolute-left h-100 w-100 opacity-0"
						value={currentValue}
						onChange={handleChange}
						aria-label={labels.get('SORT_BY')}
						onFocus={handleFocus}
						onBlur={handleBlur}
					>
						{sortOptions.map(({ value, label }) => (
							<option key={value} value={value}>
								{label}
							</option>
						))}
					</select>
				</div>
				<span className="sr-only" role="status" aria-live="polite">
					{sortAnnouncement}
				</span>
			</React.Fragment>
		);
	}

	return (
		<React.Fragment>
			<label htmlFor="sortBy" className="sr-only">
				{labels.get('SORT_BY')}
			</label>
			<select
				id="sortBy"
				className="form-control font-size-ios-zoom-override"
				value={currentValue}
				onChange={handleChange}
			>
				{sortOptions.map(({ value, label }) => (
					<option key={value} value={value}>
						{label}
					</option>
				))}
			</select>
			<span className="sr-only" role="status" aria-live="polite">
				{sortAnnouncement}
			</span>
		</React.Fragment>
	);
};

InventorySort.propTypes = {
	sortOptions: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.string,
			label: PropTypes.string
		})
	),
	isBtn: PropTypes.bool
	// displayStyle: PropTypes.string
};

InventorySort.defaultProps = {
	sortOptions: [],
	isBtn: false
	// displayStyle: ''
};

export default InventorySort;
